import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CNConsultation } from 'src/app/models/cnconsultation';
import * as moment from 'moment';
import { MatTableDataSource } from '@angular/material/table';
import { CNPatient } from 'src/app/models/cnpatient';
import { ServicesService, ServicesServiceFilter, ServicesServiceSubject } from 'src/app/services/services.service';
import { PageEvent } from '@angular/material/paginator';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-contact-services-table',
  templateUrl: './contact-services-table.component.html',
  styleUrls: ['./contact-services-table.component.scss']
})
export class ContactServicesTableComponent implements OnInit, OnDestroy {

  displayedColumns: string[] = ['contact'];
  public contacts = new MatTableDataSource<CNConsultation>();
  public subject: ServicesServiceSubject;
  private myLocation = 'default';
  private myPatient: CNPatient;
  private myShowPaginator = false;
  private myFilter = ServicesServiceFilter.all;

  private clearSub: Subscription;
  private subjectSub: Subscription;

  @ViewChild('paginator', { static: true }) thePaginator;
  @Input() pageSize = 5;

  constructor(public servicesservice: ServicesService) { }

  ngOnInit(): void {
    this.clearSub = this.servicesservice.clear.subscribe(flag => {
      console.log('labos cleared');
      if (this.myShowPaginator && this.thePaginator) {
        this.thePaginator.pageIndex = 0;
      }
    });
  }

  ngOnDestroy(): void {
    this.clearSub.unsubscribe();
    if (this.subjectSub) {
      this.subjectSub.unsubscribe();
    }
  }

  @Input() set location(theLocation: string) {
    this.myLocation = theLocation;
    this.subject = this.servicesservice.getSubject(this.myLocation, this.myFilter, this.pageSize);
    if (this.subjectSub) {
      this.subjectSub.unsubscribe();
    }
    this.subjectSub = this.subject.consultations.subscribe(data => {
      this.contacts.data = data;
    });
    if (this.myPatient) {
      this.subject.patient = this.myPatient;
    }
  }

  @Input() set paginator(flag: boolean) {
    this.myShowPaginator = flag;
  }

  get paginator(): boolean {
    return this.myShowPaginator;
  }

  @Input() set patient(thePatient: CNPatient) {
    this.myPatient = thePatient;
    if (this.subject) {
      // subject already set, just set patient
      this.subject.clear();
      this.subject.patient = this.myPatient;
    }
  }

  changePage(event: PageEvent): void {
    if (!this.subject) {
      return;
    }
    const newStart = event.pageIndex * event.pageSize;
    if (newStart !== this.subject.start) {
      this.subject.start = newStart;
    }
    if (this.subject.limit !== event.pageSize) {
      this.subject.limit = event.pageSize;
    }
  }

  updated(event: CNConsultation) {
    setTimeout(() => {
      this.subject.start = this.subject.start; // Force reload
    });
  }

  getCreator(contact: CNConsultation): string {
    return contact.creator ? contact.creator.lastname + ' ' + contact.creator.firstname : '';
  }

  getCreatedDate(contact: CNConsultation): string {
    return moment(contact.createddate).format('DD/MM/YYYY');
  }

}
